// extracted by mini-css-extract-plugin
export default {"p_tye":"_112c0ddd4a","slcted":"_09cb1ddfed","slc_color":"f0150adb80","item_p":"d2cb45db7b","r0":"_8dfbf24b48"};